import Vue from 'vue'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import { isWebview } from '@/utils/util.js'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
    mcn: {
      text: 0,
      video: 0,
      mate:0
    },
    pageSearch: {},
    auditTips:false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_MCN: (state, obj) => {
      state.mcn = {
        text: obj.text,
        video: obj.video,
        mate:obj.mate
      }
    },
    SET_PAGESEARCH: (state, obj) => {
      state.pageSearch[obj.page] = obj.search
    },
    SET_AuditTips: (state, res) => {
      state.auditTips = res
    },

  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
          login(userInfo).then(response => {
            const result = response.result
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          if (res.code==1) {
            res.permissionList = []
            commit('SET_ROLES', res)
            commit('SET_INFO', res.result)
            commit('SET_NAME', {name: res.result.username, welcome: welcome()})
            // commit('SET_AVATAR', result.avatar)
            resolve(res)
          }else{
            resolve(res.message)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          Vue.ls.remove(ACCESS_TOKEN)
          // iframe 通知父组件 同步登出状态
          isWebview()&&window.parent.postMessage({token:''},'*')
          resolve()
        }).catch(() => {
          resolve()
        })
      })
    }

  }
}

export default user
